/**
 * The four public legal pages counsel supplied in October 2026, and the one
 * list the footers, the router, the prerender and the sitemap all read, so a
 * page is linked, routed, written to disk and listed for crawlers together or
 * not at all.
 *
 * The wording itself lives in `wanderlust-cravings-site/src/content/legal/`,
 * one text file per page, written from counsel's Word file by
 * `scripts/legal-docx-to-txt.py`.
 */
/**
 * The day the Consumer Health Data Privacy Policy goes live, as it should read
 * on the page ("November 3, 2026"). Counsel's text carries a placeholder for
 * it, and the packet is explicit that the page is not published with the
 * placeholder, so until this is set the page is not routed, linked,
 * prerendered or listed in the sitemap.
 */
export const CONSUMER_HEALTH_DATA_POLICY_PUBLISHED_ON = 'November 3, 2026';
export const PRIVACY_POLICY_PAGE = { key: 'privacy', path: '/privacy', label: 'Privacy Policy' };
export const WEBSITE_TERMS_PAGE = {
    key: 'websiteTerms',
    path: '/website-terms',
    label: 'Website Terms of Use',
};
export const BOOKING_TERMS_PAGE = {
    key: 'bookingTerms',
    path: '/booking-terms',
    label: 'Booking Terms and Conditions',
};
export const CONSUMER_HEALTH_DATA_PAGE = {
    key: 'consumerHealthData',
    path: '/consumer-health-data-privacy',
    label: 'Consumer Health Data Privacy Policy',
};
/** In the order the footers list them. */
export const LEGAL_PAGES = [
    PRIVACY_POLICY_PAGE,
    WEBSITE_TERMS_PAGE,
    BOOKING_TERMS_PAGE,
    CONSUMER_HEALTH_DATA_PAGE,
];
export function legalPagePublished(key, healthPolicyPublishedOn = CONSUMER_HEALTH_DATA_POLICY_PUBLISHED_ON) {
    return key !== 'consumerHealthData' || Boolean(healthPolicyPublishedOn?.trim());
}
export function publishedLegalPages(healthPolicyPublishedOn = CONSUMER_HEALTH_DATA_POLICY_PUBLISHED_ON) {
    return LEGAL_PAGES.filter((page) => legalPagePublished(page.key, healthPolicyPublishedOn));
}
